export const SucessFace = ({ classname }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <circle cx="35" cy="35" r="34.5" stroke="#00FFF0" />
      <path
        d="M14.9999 29.9282L15.694 29.0897C19.0462 25.0396 24.9621 24.2769 29.2319 27.3443L29.8461 27.7855"
        stroke="#00FFF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M40.0077 27.9313L40.9086 27.3204C45.26 24.3699 51.153 25.2926 54.3942 29.432L54.8605 30.0274"
        stroke="#00FFF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M28 51L28.8067 51.7308C32.7031 55.2605 38.6672 55.1703 42.4551 51.5244L43 51"
        stroke="#00FFF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  )
}
